/* eslint-disable @typescript-eslint/no-explicit-any */
import {GOOGLE_ANALYTICS_EVENTS, HUBSPOT} from './constants';
import isHubspotForm from './utils/isHubspotForm';

type Maybe<T> = T | null;
type FormInputElement = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

const HAS_STARTED_VALUE = 'true';
const VISIBLE_HUBSPOT_FORM_INPUT_SELECTOR = '.hs-input:not([type="hidden"])';

const isFormInputElement = (element: Maybe<EventTarget>): boolean =>
  Boolean(element) &&
  (element instanceof HTMLInputElement ||
    element instanceof HTMLSelectElement ||
    element instanceof HTMLTextAreaElement);

const getTargetForm = (element: Maybe<EventTarget>): Maybe<HTMLFormElement> =>
  isFormInputElement(element) ? (element as FormInputElement).form : null;

export const hubspotFormStart = ({target}: Event) => {
  const form = getTargetForm(target);

  if (!form) return;

  const {formId, started} = form.dataset;

  if (started === HAS_STARTED_VALUE) return;

  (window as any).dataLayer.push({
    event: GOOGLE_ANALYTICS_EVENTS.FORM_START,
    form_id: formId,
    form_host: HUBSPOT,
  });

  // mark form started to prevent duplicate `form_start` event push
  form.dataset.started = HAS_STARTED_VALUE;
};

const registerHubspotFormStart = (element: Maybe<HTMLElement>) => {
  if (!isHubspotForm(element)) return;

  const hsInputs = (element as HTMLFormElement).querySelectorAll(
    VISIBLE_HUBSPOT_FORM_INPUT_SELECTOR
  );

  hsInputs.forEach(hsInput => {
    (hsInput as FormInputElement).addEventListener('input', hubspotFormStart);
  });
};

export default registerHubspotFormStart;
